<template>
  <!-- 学生离班弹窗 -->
  <Modal
    v-model="leaveStudentShow"
    :title="modalTitle"
    :width="700"
    :footer-hide="true"
    :closable="false"
    @on-visible-change="afterHide"
  >
    <div class="img-block">
      <img src="../img/class-leave.png" alt="">
    </div>
    <div style="margin-bottom: 16px">
      确认将学生移出课班吗？移出后，将自动停止在本班级排课及考勤。请注意操作后的以下影响：
      <div class="color-red font-bold">
        ①离班节次后的考勤将会自动被删除。离班节次只能选择最后一节课前的节次。
      </div>
      <div class="color-red font-bold">
        ②若学生未在班级实际上课，可选择：在该班级未实际上课，进行全部节次离班。
      </div>
    </div>
    <div class="table"></div>
    <Table
      :columns="leaveColumns"
      :data="leaveData"
      max-height="500"
      border
      @on-row-click="onLeaveRowClick"
    >
      <!-- @on-row-click="onLeaveRowClick" -->
      <template
        slot="leaveClassTime"
        slot-scope="{ row, index }"
      >
        <Select
          v-model="leaveData[index]['leaveClassTime']"
          placeholder="请选择离班日期"
          clearable
          transfer
          style="width: 200px"
          :disabled="studentsLeaveLoading"
        >
          <Option
            v-for="(x,y) in classTimeListShowForRow(index)"
            :key="y"
            :value="x.leaveClassTime"
            :disabled="x.disabled"
          >{{ x.optionShow }}</Option>
        </Select>
        <Icon
          v-if="index == 0"
          class="download-icon"
          type="md-cloud-download"
          size="20"
          @click="batchSetLeaveTime"
        ></Icon>
      </template>
      <template slot="action" slot-scope="{ row, index }">
        <Button
          type="primary"
          size="small"
          style="margin-right: 5px"
          :disabled="studentsLeaveLoading"
          @click="handleShowAttendance(row, index)"
        >查看考勤</Button>
        <Button
          type="error"
          size="small"
          style="margin-right: 5px"
          :disabled="studentsLeaveLoading"
          @click="handleDeleteAttendance(row, index)"
        >删除</Button>
      </template>
    </Table>
    <div class="modal-footer">
      <Button @click="handleCancleLeave">取消</Button>
      <Button
        type="primary"
        :loading="studentsLeaveLoading"
        @click="handleSureLeave"
      >确定</Button>
    </div>
  </Modal>
</template>
<script>
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
export default {
  props: {
    classroomId: {
      type: String,
      default: ''
    },
    modalTitle: {
      type: String,
      default: '学生离班'
    },
    // 离班操作是否需要二次确认
    shouldReconfirm: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      leaveStudentShow: false, // 离班弹窗状态
      leaveColumns: [{
        title: '学生姓名',
        key: 'studentName'
      }, {
        title: '离班日期',
        slot: 'leaveClassTime',
        width: 290
      }, {
        title: '操作',
        slot: 'action',
        width: 180
      }], // 准备离班学生表格表头
      leaveData: [], // 离班学生数据
      leaveClassInfoList: [], // 离班学生数据
      studentsLeaveLoading: false,
      classTimeList: [], // 课程上课时间列表
      selectLeaveIndex: -1
    };
  },
  mounted() {
    this.getClassTimes();
  },
  methods: {
    // 获取上课节次
    async getClassTimes() {
      const params = {
        classroomId: this.classroomId,
        teacherId: 0
      };
      const res = await courseSchedulCenter.getDetailWithTeaSign(params);
      if (res.status === 200) {
        this.classTimeList = [];
        res.message.forEach((item, index) => {
          const obj = {
            classDateBeginShow: item.classTimeBegin.split(' ')[0],
            disabled: index === res.message.length - 1
          };
          obj.optionShow = `第${item.classNo}节（${obj.classDateBeginShow}）`;
          obj.leaveClassTime = obj.disabled ? '' : res.message[index + 1].classTimeBegin;
          this.classTimeList.push(obj);
        });

        this.classTimeList.unshift({
          classDateBeginShow: '',
          optionShow: '在该班级未实际上课',
          disabled: false,
          leaveClassTime: res.message[0].classTimeBegin
        });
      }
    },
    // 打开离班弹窗
    openLeaveModal(selectStudentData) {
      // this.$Spin.show();
      this.leaveStudentShow = true;
      this.leaveData = selectStudentData.map(item => {
        return {
          enrollId: item.id,
          enrollIdForChange: item.enrollId,
          leaveClassTime: '',
          studentName: item.studentName,
          studentId: item.studentId,
          payOrderId: item.payOrderId
        };
      });
    },
    // 查看考勤
    handleShowAttendance(row, index) {
      console.log('查看考勤的row', row);
      const routeUrl = this.$router.resolve({
        name: 'eduCenter_studentAttance_Index_Details',
        query: { classroomId: this.classroomId, stuId: row.studentId, payOrderId: row.payOrderId, studentName: row.studentName, studentSts: 1 }
      });

      window.open(routeUrl.href, '_blank');
    },
    // 离班学生操作表格点击
    onLeaveRowClick(row, index) {
      // console.log(row, index);
      this.selectLeaveIndex = index;
    },
    // 离班操作表格里删除
    handleDeleteAttendance(row, index) {
      this.leaveData.splice(index, 1);

      const enrollIds = this.leaveData.map(item => { return item.enrollId; });
      this.$emit('dealSelectData', enrollIds);
    },
    handleCancleLeave() {
      this.leaveStudentShow = false;
    },
    afterHide(status) {
      if (!status) {
        this.selectLeaveIndex = -1;
        this.leaveData = [];
      }
    },
    // 考勤日期选择变化
    // onLeavePickerChange(data) {
    //   console.log(data, '拿到的时间');
    //   this.leaveData[this.selectLeaveIndex]['leaveClassTime'] = data;
    // },
    // 批量设置考勤日期
    batchSetLeaveTime() {
      if (this.studentsLeaveLoading) {
        return false;
      }
      this.leaveData.forEach((item, index) => {
        if (index != 0) {
          item.leaveClassTime = this.leaveData[0]['leaveClassTime'];
        }
      });
    },
    handleSureLeave() {
      console.log('点击了确认按钮');
      if (this.shouldReconfirm) {
        this.$Modal.confirm({
          title: '离班确认',
          content: '是否确认离班操作？该操作确认后不可恢复，请再次确认该操作。',
          onOk: () => {
            this.leaveStudentTrue();
          }
        });
      } else {
        this.leaveStudentTrue();
      }
    },
    // 真正的离班
    async leaveStudentTrue() {
      if (this.leaveData.length === 0) {
        return;
      }
      const unLeaveClassTimeKey = this.leaveData.findIndex(item => { console.log(!item.leaveClassTime); return !item.leaveClassTime; });

      if (unLeaveClassTimeKey != -1) {
        this.$Message.warning('请选择离班日期');
        return null;
      }

      try {
        const leaveClassInfoList = this.leaveData.map(item => {
          return { enrollId: item.enrollId, leaveClassTime: item.leaveClassTime };
        });

        const params = {
          leaveClassInfoList,
          classroomId: this.classroomId
        };

        this.studentsLeaveLoading = true;
        this.$Spin.show();
        const res = await courseSchedulCenter.studentUnBindClassroom(params);
        this.$Spin.hide();
        if (res.status === 200) {
          this.$Message.success('离班成功');
          this.$emit('leaveSuccess', this.leaveData);
          this.handleCancleLeave();
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.studentsLeaveLoading = false;
      }
    },
    classTimeListShowForRow(index) {
      if (index === this.selectLeaveIndex) {
        return this.classTimeList;
      } else if (this.leaveData[index].leaveClassTime) {
        const obj = this.classTimeList.find(item => {
          return item.leaveClassTime === this.leaveData[index].leaveClassTime;
        });
        return obj ? [obj] : [];
      } else {
        return [];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.img-block{
  width: 100%;
  img{
    width: 100%;
  }
}
.modal-footer {
  margin-top: 32px;
  text-align: right;
  button + button {
    margin-left: 16px;
  }
}
.download-icon{
  margin-left: 8px;
}
</style>
